// extracted by mini-css-extract-plugin
module.exports = {"title":"NonFinancialSavings_title__3UUiF","icon":"NonFinancialSavings_icon__3RIMd","tabs":"NonFinancialSavings_tabs__26L0Q"};